module.exports = __webpack_public_path__ + "static/media/card_brand_hipercard.a5dc29eb.svg";